import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES,
  coursePauseRequestApproveModalStageSelector,
  setCoursePauseRequestApproveModalStage,
} from 'features/courseResume';
import CoursePauseRequestApproveModalStageRenderer from '../CoursePauseRequestApproveModalStageRenderer';

function CoursePauseRequestApproveModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(coursePauseRequestApproveModalStageSelector);
  const isModalOpen =
    modalStage !== COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.notOpen;

  const handleModalClose = useCallback(() => {
    dispatch(
      setCoursePauseRequestApproveModalStage(
        COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES.notOpen
      )
    );
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleModalClose}
      withoutHeader
      hasCloseButton={false}
    >
      <CoursePauseRequestApproveModalStageRenderer />
    </Modal>
  );
}

export default CoursePauseRequestApproveModal;
